'use client';
import Nav from '../components/nav';
import '../../studio-config';
import { Experience, ExperienceRoot } from '@contentful/experiences-sdk-react';

type Props = {
    experience?: Experience;
    variant?: 'light' | 'dark' | 'dark-transparent';
    preview: boolean;
    isExpEditorMode: boolean;
    stylesheet?: string | null;
};

function ExperiencePage(props: Props) {
    const { experience, preview, isExpEditorMode, variant = 'light', stylesheet } = props;

    const experienceJSON = experience ? JSON.stringify(experience) : null;
    return (
        <div style={{ width: '100%' }}>
            <Nav variant={variant} preview={preview} isExpEditorMode={isExpEditorMode} />
            {stylesheet && <style>{stylesheet}</style>}
            <div className="pt-20 lg:pt-40">
                <ExperienceRoot experience={experienceJSON} locale={'en-US'} />
            </div>
        </div>
    );
}

export default ExperiencePage;
